import type { EmployeeDesignation } from '../types';
import type { DebitCardAssignment, QBExpense } from '../types';
import { hasOfficeOpsPrivileges } from './employeeDesignations';
import { resolveCardholderForTransaction } from './cardExpenseMatch';

/** Admin, EA, Office Manager, and CFO may view and categorize any cardholder's pending charges. */
export function canManageCardExpensesOnBehalf(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  if (hasOfficeOpsPrivileges(args.designations)) return true;
  if (args.designations?.includes('cfo')) return true;
  return false;
}

/**
 * Header / user-menu visibility for My Card Expenses.
 * CRM #77: scoped shop/office cardholders must see this whenever they have access —
 * do not require Sales CRM (that gate bounced digests to Project Hub).
 */
export function shouldShowCardExpensesNavLink(canAccessCardExpenses: boolean): boolean {
  return canAccessCardExpenses;
}

export function expenseBelongsToUser(
  expense: Pick<
    QBExpense,
    | 'assignedUserId'
    | 'cardLastFour'
    | 'bankAccountName'
    | 'bankAccountId'
    | 'description'
    | 'sequenceCardId'
    | 'categorizationStatus'
  >,
  cards: DebitCardAssignment[],
  userId: string,
): boolean {
  const match = resolveCardholderForTransaction(expense, cards);
  if (match) return match.userId === userId;
  return expense.assignedUserId === userId;
}
